<script setup lang="ts">
import useStore from "@src/stores/store";
const store = useStore();
</script>

<template>
    <div :class="{ dark: store.settings.darkMode }" class="scrollbox" tabindex="0">
        <div class="scrollbox-content">
            <slot />
        </div>
    </div>
</template>

<style scoped>
.scrollbox {
    overflow: auto;
    scroll-behavior: smooth;
    /* remove o espaço reservado quando não tem scroll */
    scrollbar-gutter: auto;
}

/* Firefox */
.scrollbox {
    scrollbar-width: thin;
    scrollbar-color: rgba(0, 0, 0, 0.18) transparent;
}
.scrollbox.dark {
    scrollbar-color: rgba(255, 255, 255, 0.18) transparent;
}

/* Webkit */
.scrollbox::-webkit-scrollbar {
    width: 10px;
    height: 10px;
}

.scrollbox::-webkit-scrollbar-track {
    background: transparent;
}

.scrollbox::-webkit-scrollbar-thumb {
    /* bem suave por padrão */
    background-color: rgba(0, 0, 0, 0.14);
    border-radius: 999px;
    /* cria “gap” pra parecer mais leve */
    border: 3px solid transparent;
    background-clip: content-box;
    transition: background-color 180ms ease;
}

.scrollbox.dark::-webkit-scrollbar-thumb {
    background-color: rgba(255, 255, 255, 0.14);
}

.scrollbox:hover::-webkit-scrollbar-thumb,
.scrollbox:focus::-webkit-scrollbar-thumb,
.scrollbox:focus-within::-webkit-scrollbar-thumb {
    /* realça só quando interage */
    background-color: rgba(0, 0, 0, 0.26);
}

.scrollbox.dark:hover::-webkit-scrollbar-thumb,
.scrollbox.dark:focus::-webkit-scrollbar-thumb,
.scrollbox.dark:focus-within::-webkit-scrollbar-thumb {
    background-color: rgba(255, 255, 255, 0.28);
}
</style>
